import React from "react";
import {css, Theme} from "@emotion/react";

import {Badge} from "@pg-design/badge-module";
import {position} from "@pg-design/helpers-css";
import {Picture} from "@pg-design/picture-module";
import {AIMarkingBadge, getAIMarkingTypeFromFlags} from "@pg-mono/ai-marking";

import {getThumbnailLink} from "../../../utils/get_thumbnail_link";

interface IProps {
    article: {
        gallery: (
            | {
                  image_url: string | null;
              }
            | undefined
        )[];
        is_sponsored: boolean;
        ai_modified: boolean;
        ai_created: boolean;
        title: string;
    };
}

export const ArticleMainImage: React.FunctionComponent<IProps> = (props) => {
    const {
        article: {title, gallery, ai_created, ai_modified}
    } = props;

    const aiMarkingBadgeType = getAIMarkingTypeFromFlags({isModified: ai_modified, isCreated: ai_created});

    return (
        <div css={position("relative")}>
            <div css={badgesWrapper}>
                {props.article.is_sponsored ? (
                    <Badge variant="label_highlight" css={badge}>
                        artykuł sponsorowany
                    </Badge>
                ) : null}
                {aiMarkingBadgeType ? <AIMarkingBadge type={aiMarkingBadgeType} transparent css={aiMarkingBadge} /> : null}
            </div>
            <Picture
                css={picture}
                sources={[
                    {minWidthPX: 0, width: 440, height: 440, src: getThumbnailLink(gallery[0]?.image_url, 440, 440)},
                    {minWidthPX: 480, width: 728, height: 400, src: getThumbnailLink(gallery[0]?.image_url, 728, 400)},
                    {minWidthPX: 768, width: 1160, height: 638, src: getThumbnailLink(gallery[0]?.image_url, 1160, 638)}
                ]}
                alt={title}
                fetchPriority="high"
            />
        </div>
    );
};

const badgesWrapper = css`
    position: absolute;
    top: 2.4rem;
    left: 2.4rem;
    z-index: 2;
    display: flex;
    align-items: center;
    gap: 0.8rem;
`;

const badge = (theme: Theme) => css`
    background-color: ${theme.colors.primary};
`;

const aiMarkingBadge = css`
    height: 2.2rem;
    width: auto;
`;

const picture = css`
    & img {
        width: 100%;:
    }
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {Badge} from "@pg-design/badge-module";
import {position} from "@pg-design/helpers-css";
import {Picture} from "@pg-design/picture-module";
import {AIMarkingBadge, getAIMarkingTypeFromFlags} from "@pg-mono/ai-marking";

import {getThumbnailLink} from "../../../utils/get_thumbnail_link";

interface IProps {
    article: {
        gallery: (
            | {
                  image_url: string | null;
              }
            | undefined
        )[];
        is_sponsored: boolean;
        ai_modified: boolean;
        ai_created: boolean;
        title: string;
    };
}

export const ArticleMainImage: React.FunctionComponent<IProps> = (props) => {
    const {
        article: {title, gallery, ai_created, ai_modified}
    } = props;

    const aiMarkingBadgeType = getAIMarkingTypeFromFlags({isModified: ai_modified, isCreated: ai_created});

    return (
        <div css={position("relative")}>
            <div css={badgesWrapper}>
                {props.article.is_sponsored ? (
                    <Badge variant="label_highlight" css={badge}>
                        artykuł sponsorowany
                    </Badge>
                ) : null}
                {aiMarkingBadgeType ? <AIMarkingBadge type={aiMarkingBadgeType} transparent css={aiMarkingBadge} /> : null}
            </div>
            <Picture
                css={picture}
                sources={[
                    {minWidthPX: 0, width: 440, height: 440, src: getThumbnailLink(gallery[0]?.image_url, 440, 440)},
                    {minWidthPX: 480, width: 728, height: 400, src: getThumbnailLink(gallery[0]?.image_url, 728, 400)},
                    {minWidthPX: 768, width: 1160, height: 638, src: getThumbnailLink(gallery[0]?.image_url, 1160, 638)}
                ]}
                alt={title}
                fetchPriority="high"
            />
        </div>
    );
};

const badgesWrapper = css`
    position: absolute;
    top: 2.4rem;
    left: 2.4rem;
    z-index: 2;
    display: flex;
    align-items: center;
    gap: 0.8rem;
`;

const badge = (theme: Theme) => css`
    background-color: ${theme.colors.primary};
`;

const aiMarkingBadge = css`
    height: 2.2rem;
    width: auto;
`;

const picture = css`
    & img {
        width: 100%;:
    }
`;
